import React, { useState, useEffect } from 'react';
import './TopArrowButton.css'; // Import the CSS file for styling

const TopArrowButton = () => {
    const [isVisible, setIsVisible] = useState(false);

    // Show button when page is scrolled down
    const toggleVisibility = () => {
        if (window.pageYOffset > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    // Scroll to top of the page
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    useEffect(() => {
        window.addEventListener('scroll', toggleVisibility);
        return () => {
            window.removeEventListener('scroll', toggleVisibility);
        };
    }, []);

    return (
        <div className="top-arrow-button">
            {isVisible && (
                <button onClick={scrollToTop}>
                    &#8679; {/* Unicode for an up arrow */}
                </button>
            )}
        </div>
    );
};

export default TopArrowButton;
